import classNames from "classnames"
import { useEffect, useState } from "react"

type FloatingBannerProps = {
  children: React.ReactNode
  isVisible: boolean
}

export const FloatingBanner = ({ children, isVisible }: FloatingBannerProps) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(isVisible)
  }, [isVisible])

  return (
    <div
      className={classNames(
        "fixed left-0 top-0 z-20 w-full transition-transform duration-1000 ease-in-out",
        visible ? "translate-y-0" : "translate-y-[-150%]",
      )}>
      {children}
    </div>
  )
}
